<div class="modal active coverageOptions">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>{{ title }}</h2>
      <div class="close" (click)="cancelCoverage()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  class="active" id="ngForm" name="ngForm" #ngForm="ngForm">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Layer Settings</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Calculation Name</label>
                  <input name="calculationName" type="text" [(ngModel)]="calculationControlService.coverageDTOModal.calculationName" [required]="true"
                  #calculationName="ngModel" alphaNumeric forbiddenSubstring={{forbiddenSubstringName}}
                  />
                  <span class="error" *ngIf="calculationName.errors?.forbiddenName">
                    Name cannot contain {{forbiddenSubstringName}}.
                  </span>
                  <span class="error" *ngIf=" (calculationName.dirty || calculationName.touched) && calculationName.errors?.nonAlphaNumeric">
                    Only alphanumeric characters, hyphens and underscores are allowed.
                  </span>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Calculation Mode</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <input type="checkbox" [checked]="calculationControlService.coverageDTOModal.isSingleLevel" (change)="changeSelection()"/>
                  <label for="">Use Single Level</label>
                  <p *ngIf="this.coverage_type == 'OVERLAP'"> Coverage Limitation: Radio Horizon</p>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Single Altitude Parameteres (AMSL)</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Single Level Altitude</label>
                  <div class="coordenates">
                    <input id="singleLevelAltitudeFeet" name="singleLevelAltitudeFeet" #singleLevel='ngModel' [(ngModel)]="calculationControlService.coverageDTOModal.singleAltitude"
                    (ngModelChange)="calculationControlService.coverageDTOModal.singleAltitudeMeters=pointsController.convertToMeters($event)"
                    type="number" style="width: 30%" [required]="calculationControlService.coverageDTOModal.isSingleLevel" [disabled]="!calculationControlService.coverageDTOModal.isSingleLevel"/><span>[ft]</span>
                    <input id="singleLevelAltitudeMeters" name="singleLevelAltitudeMeters" [(ngModel)]="calculationControlService.coverageDTOModal.singleAltitudeMeters"
                    (ngModelChange)="calculationControlService.coverageDTOModal.singleAltitude=pointsController.convertToFeet($event)"
                    type="number" style="width: 30%" [required]="!isSingleLevelDisabled" [disabled]="!calculationControlService.coverageDTOModal.isSingleLevel"/><span>[m]</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Alt. Range Parameteres (AMSL)</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Max Altitude</label>
                  <div class="coordenates">
                    <input id="maxAltitudeAltitudeFeet" name="maxAltitudeAltitudeFeet" type="number" #maxAltitude='ngModel' [(ngModel)]="calculationControlService.coverageDTOModal.maxAltitude"
                    (ngModelChange)="calculationControlService.coverageDTOModal.maxAltitudeMeters=pointsController.convertToMeters($event)"
                    style="width: 30%" [required]="!calculationControlService.coverageDTOModal.isSingleLevel" [disabled]="calculationControlService.coverageDTOModal.isSingleLevel"/><span>[ft]</span
                    ><input id="maxAltitudeAltitudeMeters" name="maxAltitudeAltitudeMeters" [(ngModel)]="calculationControlService.coverageDTOModal.maxAltitudeMeters"
                    (ngModelChange)="calculationControlService.coverageDTOModal.maxAltitude=pointsController.convertToFeet($event)"
                    type="number" style="width: 30%" [required]="isSingleLevelDisabled" [disabled]="calculationControlService.coverageDTOModal.isSingleLevel"/><span>[m]</span>
                  </div>
                </div>
                <div>
                  <label for="">Min Altitude</label>
                  <div class="coordenates">
                    <input id="minAltitudeFeet" name="minAltitudeFeet" #minAltitude='ngModel' [(ngModel)]="calculationControlService.coverageDTOModal.minAltitude"
                    (ngModelChange)="calculationControlService.coverageDTOModal.minAltitudeMeters=pointsController.convertToMeters($event)"
                    type="number" style="width: 30%" [required]="!calculationControlService.coverageDTOModal.isSingleLevel" [disabled]="calculationControlService.coverageDTOModal.isSingleLevel"/><span>[ft]</span
                    ><input id="minAltitudeMeters" name="minAltitudeMeters" [(ngModel)]="calculationControlService.coverageDTOModal.minAltitudeMeters"
                    (ngModelChange)="calculationControlService.coverageDTOModal.minAltitudeMeters=pointsController.convertToFeet($event)"
                    type="number" style="width: 30%" [required]="isSingleLevelDisabled" [disabled]="calculationControlService.coverageDTOModal.isSingleLevel"/><span>[m]</span>
                  </div>
                </div>
                <div>
                  <label for="">Altitude Increment</label>
                  <div class="coordenates">
                    <input id="altitudeIncrementFeet" name="altitudeIncrementFeet" #altitudeIncrement='ngModel' [(ngModel)]="calculationControlService.coverageDTOModal.altitudeInterval"
                    (ngModelChange)="calculationControlService.coverageDTOModal.altitudeIntervalMeters=pointsController.convertToMeters($event)"
                    type="number" style="width: 30%" [required]="!calculationControlService.coverageDTOModal.isSingleLevel" [disabled]="calculationControlService.coverageDTOModal.isSingleLevel"/><span>[ft]</span
                    ><input id="altitudeIncrementMeters" name="altitudeIncrementMeters" [(ngModel)]="calculationControlService.coverageDTOModal.altitudeIntervalMeters"
                    (ngModelChange)="calculationControlService.coverageDTOModal.altitudeInterval=pointsController.convertToFeet($event)"
                     type="number" style="width: 30%" [required]="!calculationControlService.coverageDTOModal.isSingleLevel" [disabled]="calculationControlService.coverageDTOModal.isSingleLevel"/><span>[m]</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button
              type="submit"
              [ngClass]="ngForm.form.valid ? 'blue' : 'gray'"
              (click)="calculate(); ngForm.reset()"
              [disabled]="!ngForm.form.valid"
            >Ok</button>
            <button class="gray" type="reset" (click)="cancelCoverage()" value="Cancel">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
